import { render, staticRenderFns } from "./newProductCheck.vue?vue&type=template&id=5c97a8ae&scoped=true&"
import script from "./newProductCheck.vue?vue&type=script&lang=js&"
export * from "./newProductCheck.vue?vue&type=script&lang=js&"
import style0 from "./newProductCheck.vue?vue&type=style&index=0&id=5c97a8ae&prod&scoped=true&lang=less&"
import style1 from "./newProductCheck.vue?vue&type=style&index=1&id=5c97a8ae&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c97a8ae",
  null
  
)

export default component.exports